import { advancedControlsPage } from './advanced-controls';
import { portfolioBidStrategyPage } from './portfolio-bid-strategy';

export const bidStrategiesPages = [
  advancedControlsPage,
  portfolioBidStrategyPage,
];
